import React, { use, useEffect, useState } from "react";
import { AdminHeader } from "../components/Common/CompanyAdminHeader";
import { useUserStore } from "../stores/user-store";
import { useAuthStore } from "../stores/auth-store";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Button } from "../components/UI/Button";
import InfoMessageModal from "../components/UI/InfoMessageModal";
import { formatMobile } from "../../shared/utils/format-mobile";

const EditProfile1: React.FC = () => {
  const navigate = useNavigate();

  const { user } = useAuthStore();

  const [infoMessage, setInfoMessage] = useState("");

  const [searchParams] = useSearchParams();
  const infoMessageArgument = searchParams.get("infoMessage");

  useEffect(() => {
    if (infoMessageArgument) {
      setInfoMessage(infoMessageArgument);
    }
  }, [infoMessageArgument]);

  const handleLogoClick = () => {
    navigate(`/company/${user?.companyId}/admin/`);
  };

  const handleBackClick = () => {
    if (user?.role === "COMPANY_ADMIN") {
      navigate(`/company/${user?.companyId}/admin`);
    }
    if (user?.role === "ADMIN") {
      navigate("/admin");
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      {/* 공용 헤더 사용 */}
      <AdminHeader onLogoClick={handleLogoClick} showMyPageLink={true} />

      {/* 메인 콘텐츠 */}
      <div className="flex flex-col items-center / mt-10">
        <div className="w-full max-w-[46.875rem] px-5">
          <div className="flex flex-row items-center gap-5 / w-[100%] / mb-6">
            <div role="button" onClick={handleBackClick}>
              <svg
                width="8"
                height="12"
                viewBox="0 0 8 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M7.12095 0.170067C7.32709 0.376209 7.34583 0.698787 7.17717 0.926099L7.12095 0.991223L2.11243 6L7.12095 11.0088C7.32709 11.2149 7.34583 11.5375 7.17717 11.7648L7.12095 11.8299C6.91481 12.0361 6.59223 12.0548 6.36492 11.8862L6.29979 11.8299L0.880438 6.41058C0.674296 6.20444 0.655556 5.88186 0.824217 5.65455L0.880438 5.58942L6.29979 0.170067C6.52655 -0.056689 6.89419 -0.056689 7.12095 0.170067Z"
                  fill="#252525"
                />
              </svg>
            </div>
            <h2 className="text-xl md:text-2xl font-bold">프로필 수정</h2>
          </div>
          <div className="h-[0.0625rem] / bg-gray-200 / mb-8"></div>

          <h3 className="w-full / text-left font-bold / mb-3">기본 정보</h3>

          <div className="mb-[0.9375rem] / rounded-[0.5rem] / border border-separate border-tools-table-outline border-[#d9d9d9] border-1">
            <table className="text-left / w-full">
              <tbody>
                <tr className="border-b border-[#d9d9d9]">
                  <td className="py-4 / text-left text-[14px] md:text-base pl-5 min-[25rem]:pl-10">
                    아이디
                  </td>
                  <td className="py-4 text-[14px] md:text-base text-left pr-5">{user?.email}</td>
                </tr>
                <tr className="border-b border-[#d9d9d9]">
                  <td className="py-4 / text-left text-[14px] md:text-base pl-5 min-[25rem]:pl-10">
                    이름
                  </td>

                  <td className="py-4 pr-5 / text-[14px] md:text-base / text-left / flex flex-row items-center justify-between">
                    {user?.name}
                    <a href="/profile/update?mode=name">
                      <svg
                        className="transform rotate-180"
                        width="8"
                        height="12"
                        viewBox="0 0 8 12"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M7.12095 0.170067C7.32709 0.376209 7.34583 0.698787 7.17717 0.926099L7.12095 0.991223L2.11243 6L7.12095 11.0088C7.32709 11.2149 7.34583 11.5375 7.17717 11.7648L7.12095 11.8299C6.91481 12.0361 6.59223 12.0548 6.36492 11.8862L6.29979 11.8299L0.880438 6.41058C0.674296 6.20444 0.655556 5.88186 0.824217 5.65455L0.880438 5.58942L6.29979 0.170067C6.52655 -0.056689 6.89419 -0.056689 7.12095 0.170067Z"
                          fill="#252525"
                        />
                      </svg>
                    </a>
                  </td>
                </tr>
                <tr className="border-b border-[#d9d9d9]">
                  <td className="py-4 / text-left text-[14px] md:text-base pl-5 min-[25rem]:pl-10">
                    비밀번호
                  </td>
                  <td className="py-4 pr-5 / text-[14px] md:text-base / text-left / flex flex-row items-center justify-between">
                    ************
                    <a href="/profile/update?mode=password">
                      <svg
                        className="transform rotate-180"
                        width="8"
                        height="12"
                        viewBox="0 0 8 12"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M7.12095 0.170067C7.32709 0.376209 7.34583 0.698787 7.17717 0.926099L7.12095 0.991223L2.11243 6L7.12095 11.0088C7.32709 11.2149 7.34583 11.5375 7.17717 11.7648L7.12095 11.8299C6.91481 12.0361 6.59223 12.0548 6.36492 11.8862L6.29979 11.8299L0.880438 6.41058C0.674296 6.20444 0.655556 5.88186 0.824217 5.65455L0.880438 5.58942L6.29979 0.170067C6.52655 -0.056689 6.89419 -0.056689 7.12095 0.170067Z"
                          fill="#252525"
                        />
                      </svg>
                    </a>
                  </td>
                </tr>
                <tr className="border-[#d9d9d9]">
                  <td className="py-4 / text-left text-[14px] md:text-base pl-5 min-[25rem]:pl-10">
                    휴대폰 번호
                  </td>
                  <td className="py-4 pr-5 / text-[14px] md:text-base / text-left / flex flex-row items-center justify-between">
                    {user?.mobile ? (
                      <div>{formatMobile(user?.mobile)}</div>
                    ) : (
                      <div className="text-gray-500">(등록된 번호 없음)</div>
                    )}
                    <a href="/profile/update?mode=mobile">
                      <svg
                        className="transform rotate-180"
                        width="8"
                        height="12"
                        viewBox="0 0 8 12"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M7.12095 0.170067C7.32709 0.376209 7.34583 0.698787 7.17717 0.926099L7.12095 0.991223L2.11243 6L7.12095 11.0088C7.32709 11.2149 7.34583 11.5375 7.17717 11.7648L7.12095 11.8299C6.91481 12.0361 6.59223 12.0548 6.36492 11.8862L6.29979 11.8299L0.880438 6.41058C0.674296 6.20444 0.655556 5.88186 0.824217 5.65455L0.880438 5.58942L6.29979 0.170067C6.52655 -0.056689 6.89419 -0.056689 7.12095 0.170067Z"
                          fill="#252525"
                        />
                      </svg>
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="w-full / flex flex-row justify-end / text-[0.875rem] / underline">
            {/* COMPANY_ADMIN 은 개인 탈퇴가 아니라 쇼핑몰을 닫는 절차라 문구를 달리한다. */}
            <a href="/profile/unregister">
              <div role="button">
                {user?.role === "COMPANY_ADMIN" ? "사이트 운영 종료" : "회원 탈퇴"}
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditProfile1;
